import { Button, Cell, FormControl, Grid } from 'bold-ui'
import { useAlert } from 'components/alert'
import { Form, FormRenderProps, TextField } from 'components/form'
import React, { useState } from 'react'
import { metaPath } from 'util/metaPath'
import { createValidator, maxLength, required } from 'util/validation'

import { UnificarBasesChaveValidada } from './UnificarBasesChaveValidada'

export interface ValidacaoSenhaFormProps {
  conexaoInternet: boolean
}

export interface ValidacaoSenhaModel {
  senha?: string
}

export const validate = createValidator<ValidacaoSenhaModel>({
  senha: [required, maxLength(255)],
})

type EstadoComponenteValidacaoSenha = 'VALIDACAO_ENVIADA' | 'SOLICITAR_VALIDACAO'

export const ValidacaoSenhaForm = (props: ValidacaoSenhaFormProps) => {
  const path = metaPath<ValidacaoSenhaModel>()
  const { conexaoInternet } = props
  const alert = useAlert()
  const [componentState, setComponentState] = useState<EstadoComponenteValidacaoSenha>()
  const onSubmit = () => {
    if (!conexaoInternet) {
      alert(
        'warning',
        'Não é possível unificar a base sem conexão com a internet. Habilite a conexão ou tente novamente mais tarde.'
      )
    } else {
      setComponentState('VALIDACAO_ENVIADA')
    }
  }
  const renderForm = (formProps: FormRenderProps<ValidacaoSenhaModel>) => {
    return (
      <Grid gap={1}>
        <Cell size={5}>
          <h4>2. Chave gerada pelo destinatário</h4>
        </Cell>
        <Cell size={7} />
        <Cell size={4}>
          <TextField name={path.senha} label='Chave' maxLength={255} required />
        </Cell>
        <Cell size={6}>
          <FormControl label={<span>&nbsp;</span>}>
            <Button size='small' kind='primary' onClick={formProps.handleSubmit}>
              Validar
            </Button>
          </FormControl>
        </Cell>
        {componentState === 'VALIDACAO_ENVIADA' && (
          <Cell size={6}>
            <UnificarBasesChaveValidada />
          </Cell>
        )}
      </Grid>
    )
  }
  return <Form<ValidacaoSenhaModel> onSubmit={onSubmit} render={renderForm} validate={validate} />
}
